import React, { PureComponent, Fragment } from 'react';

//Import Component
import NavBar from "../components/NavBar";
import Banner from "../components/banner/Banner";
import About from "../components/About";
//import Team from "../components/Team";
import Product from "../components/Product";
import Pricing from "../components/Pricing";
import Payment from "../components/Payment";
import FAQ from "../components/FAQ";
import Contact from "../components/Contact";
import Footer from "../components/Footer";
import { PAYMENT_TAB } from '../constants/Payment';

class Home extends PureComponent {

  state = {
    paymentTab: PAYMENT_TAB.MONTHLY
  }

  changeTab = (selected) => {
    this.setState({
      paymentTab: selected
    })
  }

  render() {
    const { paymentTab } = this.state;
    return (
        <Fragment>
            {/* NavBar: src/components/NavBar.jsx */}
            <NavBar pageName="home" />
            {/* Banner: src/components/banner/Banner.jsx */}
            <Banner />
            {/* About: src/components/About.jsx */}
            <About />
            {/*<Product /> */}
            {/* Pricing: src/components/Pricing.jsx */}
            <Pricing changeTab={this.changeTab} />
            {/* Payment: src/components/Payment.jsx */}
            <Payment tab={paymentTab} changeTab={this.changeTab}  />
            {/* Team: src/components/Team.jsx */}
            {/*<Team />*/}
            {/* FAQ: src/components/FAQ.jsx */}
            <FAQ />
            {/* Contact: src/components/Contact.jsx */}
            <Contact />
            {/* Footer: src/components/Footer.jsx */}
            <Footer />
        </Fragment>
    );
  }
}

export default Home;
